import { render } from "./partnerTrSet.vue?vue&type=template&id=375985b4&scoped=true"
import script from "./partnerTrSet.vue?vue&type=script&lang=js"
export * from "./partnerTrSet.vue?vue&type=script&lang=js"

import "./partnerTrSet.vue?vue&type=style&index=0&id=375985b4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-375985b4"]])

export default __exports__